import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import includes from 'lodash/includes';

var Trigger = /*#__PURE__*/function (_Component) {
  _inherits(Trigger, _Component);

  var _super = _createSuper(Trigger);

  function Trigger() {
    var _this;

    _classCallCheck(this, Trigger);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {};
    return _this;
  }

  _createClass(Trigger, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (Trigger.count === 0) {
        document.body.addEventListener('keydown', Trigger.onKeydown);
      }

      Trigger.count += 1;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var onClose = this.props.onClose;
      var index = Trigger.instanceList.findIndex(function (c) {
        return c === onClose;
      });

      if (index > -1) {
        Trigger.instanceList.splice(index, 1);
      }

      Trigger.count -= 1;

      if (Trigger.count === 0) {
        document.body.removeEventListener('keydown', Trigger.onKeydown);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return /*#__PURE__*/React.createElement(React.Fragment, null, children);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      var visible = nextProps.visible,
          onClose = nextProps.onClose,
          disabled = nextProps.disabled;
      onClose && (onClose.disabled = disabled);

      if (visible === true && typeof onClose === 'function') {
        if (!includes(Trigger.instanceList, onClose)) {
          Trigger.instanceList.push(onClose);
        }
      } else {
        var index = Trigger.instanceList.findIndex(function (c) {
          return c === onClose;
        });

        if (index > -1) {
          Trigger.instanceList.splice(index, 1);
        }
      }

      return null;
    }
  }, {
    key: "onKeydown",
    value: function onKeydown(e) {
      if (e.keyCode === 27) {
        var lens = Trigger.instanceList.length;
        var last = Trigger.instanceList[lens - 1];

        if (last) {
          if (last.disabled) {
            return;
          }

          last();
        }
      }
    }
  }]);

  return Trigger;
}(Component);

Trigger.defaultProps = {
  disabled: false
};
Trigger.count = 0;
Trigger.instanceList = [];
export default Trigger;